import { RevelioPageId } from '../../PageConfigProvider/types';
import type { ChartType } from '../../PageConfigProvider/types/chart';

export const isCompositionTimeseries = (chartType: ChartType) =>
  chartType === 'line' || chartType === 'share-of-segment';

export const shouldGetSelectionBreakdowns = (
  chartType: ChartType,
  revelioPageId?: RevelioPageId
) =>
  ((revelioPageId === RevelioPageId.COMPANY_COMPOSITION ||
    revelioPageId === RevelioPageId.INDUSTRY_COMPOSITION ||
    revelioPageId === RevelioPageId.GEOGRAPHY_COMPOSITION) &&
    (chartType === 'line' || chartType === 'share-of-segment')) ||
  !revelioPageId;
